import React from 'react'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'


class Bussv extends React.PureComponent {
  render() {
    return (
      <div>

        <p>
          SV Bussv Component
        </p>
      
       
     <h1>
        Blue Bussv Header
        <Badge bg="secondary" as={Button}>
          New Bussv Bage
        </Badge>
      </h1>
        
      </div>
    )
  }
}

export default Bussv
